import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Popup } from 'ng2-opd-popup';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../../services/admin';
import { Agent_Mef } from 'model/modal-cms/aget_mef';
import { Users } from 'model/modal-cms/users';
import { CMSService } from '../../services/cms-service';
import { Epidemimie } from 'model/modal-cms/epidemie';
declare var mdtoast: any;
declare var $;
var success_message = mdtoast("Bienvenue au Centre Médico–Social du Ministère (CMSM).", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message_vide = mdtoast('Authentification echouée.', { duration: 5000, init: true, type: mdtoast.ERROR });
var error_message = mdtoast('Authentification échouée.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });
var errorConnexion_message = mdtoast('Connexion échouée (Entre ROHI et TOMADY).', { duration: 5000, init: true, type: mdtoast.ERROR });
var errorConnexion_message2 = mdtoast('Connexion échouée (Entre CMS et TOMADY).', { duration: 5000, init: true, type: mdtoast.ERROR });
@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
    test: Date = new Date();
    focus;
    focus1;
    @ViewChild('popup5') popup5: Popup;
    id_agent_actuel: any;
    inscrit: any = "OK";
    nonInscrit: any = "Non";
    code: string = "ABCDEFghojklm123456789";
    //agent_Mef: Agent_Mef;
    users: Users = new Users(null);
    s: any
    s2: any;
    agent_Mef: Agent_Mef = new Agent_Mef(null);
    epidemimie: Epidemimie = new Epidemimie(null)
    loading = false;

    @Input()
    public alerts: Array<IAlert> = [];
    private backup: Array<IAlert>;
    nbr_quest_en_attante: any;

    constructor(private router: Router, private adminService: AdminService, public cmsService: CMSService, ) {
        this.agent_Mef = new Agent_Mef(null);

    }

    ngOnInit() {

    }


    login(log, mtp) {
        if (log == "" || mtp == "") {
            error_message.show();
        } else if (log == "cms_daf" || log == "com_daf") {
            this.adminService.getUserCMSConnected(log, mtp)
                .subscribe(data => {
                    if (data == null) {
                        error_message.show();
                    } else {
                        this.id_agent_actuel = data.matricule
                        if (log == "com_daf") {
                            //SPLITE CIN
                            let x = data.matricule.split(" ");
                            let y = x[0]
                            let z = x[1]
                            let w = x[2]
                            let v = x[3]
                            let s = y + z + w + v
                            this.s2 = y + "%" + z + "%" + w
                            console.log(s);
                            this.adminService.getlisteWSDrh2(s, this.code)
                                .subscribe(data => {
                                    this.adminService.setConnectedEmployer(data);
                                }, err => {
                                    console.log(err);
                                });

                        } else {
                            this.listeWSDrh2();
                        }

                        this.adminService.setUserloginUserCMS(log, mtp)
                        this.recupererAgentFamille();
                        //nafindra any amin'ny recupererAgentFamille
                        //this.AjouterVisiteur();
                        //this.router.navigate(['home']);
                    }

                }, err => {
                    console.log(err);
                })
        } else {
            //mande rohy
            this.adminService.sendloginWSRohy(log, mtp, this.code)
                .subscribe(data => {
                    if (data.valide == 0) {
                        error_message.show();
                    } else {
                        if (data.matricule == "ECD") {
                            this.id_agent_actuel = data.cin;
                            //SPLITE CIN
                            let x = data.cin.split(" ");
                            let y = x[0]
                            let z = x[1]
                            let w = x[2]
                            let v = x[3]
                            let s = y + z + w + v
                            this.s2 = y + "%" + z + "%" + w
                            this.adminService.getlisteWSDrh2(s, this.code)
                                .subscribe(data => {
                                    this.adminService.setConnectedEmployer(data);
                                }, err => {
                                    console.log(err);
                                });
                            this.recupererAgentFamille();
                            //nafindra any amin'ny recupererAgentFamille
                            //this.AjouterVisiteur();
                            //this.router.navigate(['home']);
                            this.adminService.setUserloginUserCMS(log,mtp)
                        } else {
                            this.id_agent_actuel = data.matricule;
                            this.listeWSDrh2();
                            this.recupererAgentFamille();

                            //nafindra any amin'ny recupererAgentFamille
                            //this.AjouterVisiteur();
                            //this.router.navigate(['home']);
                            this.adminService.setUserloginUserCMS(log, mtp)
                        }
                    }
                }, err => {
                    console.log(err);
                    errorConnexion_message.show();
                })
        }
    }


    listeWSDrh2() {
        this.adminService.getlisteWSDrh2(this.id_agent_actuel, this.code)
            .subscribe(data => {
                this.adminService.setConnectedEmployer(data);
            }, err => {
                console.log(err);
            });
        //save user connected

    }

    recupererAgentFamille_() {
        this.adminService.setUserIscrit(this.nonInscrit, this.id_agent_actuel)
        this.AjouterVisiteur();
        this.getinfoipdemie();
        this.setDefaultVideo();
        this.loading = true;
        this.getnombreQuestionEnAttante();
        this.router.navigate(['home']);
    }


    recupererAgentFamille() {
        this.adminService.getlisteFamille(this.id_agent_actuel)
            .subscribe(data => {
                if (data.length == 0) {
                    this.adminService.setUserIscrit(this.nonInscrit, this.id_agent_actuel)
                } else if (data.length != 0) {
                    this.adminService.setUserIscrit(this.inscrit, this.id_agent_actuel)
                    this.adminService.setUserIscrit_id(data.id)
                }
                this.AjouterVisiteur();
                this.setDefaultVideo();
                this.loading = true;
                this.router.navigate(['home']);
               
            }, err => {
                errorConnexion_message2.show();
            })
    }



    //test totosoa  336140     im: chef 322670   mm Tiana 340909
    login_ok(log, mtp) {
        if (log == "" || mtp == "") {
            error_message.show();
        } else {
            this.adminService.sendloginWSRohy(log, mtp, this.code)
                .subscribe(data => {
                    if (data.valide == 0) {
                        error_message.show();
                    } else {
                        if (data.matricule == "ECD") {
                            this.id_agent_actuel = data.cin;
                            this.listeWSDrh2();
                            this.recupererAgentFamille();
                            this.AjouterVisiteur();
                            this.router.navigate(['home']);
                        } else {
                            this.id_agent_actuel = data.matricule;
                            this.listeWSDrh2();
                            this.recupererAgentFamille();
                            this.router.navigate(['home']);
                        }
                    }
                }, err => {
                    console.log(err);
                })
        }
    }





    open() {
        this.popup5.options = {

            cancleBtnClass: "btn btn-danger",
            confirmBtnClass: "btn btn-success",
            color: "#0F7B79",
            showButtons: true,
            animationDuration: 2.5,
            header: "Information de compte oublié",
            widthProsentage: 38,
            animation: "bounceIn", //fadeInLeft fadeInRight fadeInUp fadeInDown bounceIn  bounceInDown
            confirmBtnContent: "Essayer",
            cancleBtnContent: "Fermer",
        }

        this.popup5.show(this.popup5.options);
    }

    essayer() {
        this.popup5.hide();
    }



    AjouterVisiteur() {
        this.agent_Mef.agent_matricule = this.id_agent_actuel
        this.agent_Mef.date_deb_visiteur = new Date();
        //set date deb visiteur
        this.adminService.setDateDebVisiteur(this.agent_Mef.date_deb_visiteur)
        this.adminService.saveUserConnected(this.agent_Mef).subscribe(data => {
            if (data.err) {
                //toastr.error(data.err);return;
            }
            success_message.show();
        }, err => {
        })

    }


    //recuprer info epidemie

    getinfoipdemie() {
        let etat = "ACTU"
        this.cmsService.getInfoEvolutionEpidemiebyetet(etat)
            .subscribe(data => {
                this.adminService.setEvolutionEpidemi(data.text_epid, data.hafatra_pst)

            },
                err => {
                    console.log(err);
                })
    }



    //recuprer default video
    setDefaultVideo() {
        let etat = "E_ACTU"
        this.cmsService.getDefaultVideo(etat)
            .subscribe(data => {
                console.log("data.fichier_iec" + data.fichier_iec);
                this.adminService.setDefaultVideo(data.fichier_iec)

            },
                err => {
                    console.log(err);
                })
    }



    //recuperer message

    
  //set question
  getnombreQuestionEnAttante() {
    this.adminService.getnombreQuestionEnAttante("c")
      .subscribe(data => {
        this.nbr_quest_en_attante = data;
        console.log("  this.nbr_quest_en_attante = data;" + data)
        this.adminService.setMessage_User(this.nbr_quest_en_attante)
       
      }, err => {

      })
  }








}


export interface IAlert {
  id: number;
  type: string;
  message: string;
  icon?: string;
}









